export enum RoleScope {
  ORG = "ORG",
  LOC = "LOC",
  OU = "OU"
}
